import { render, staticRenderFns } from "./AstraTopElementPlannedBonusTableColumn.vue?vue&type=template&id=2aa12367&scoped=true"
import script from "./AstraTopElementPlannedBonusTableColumn.vue?vue&type=script&lang=js"
export * from "./AstraTopElementPlannedBonusTableColumn.vue?vue&type=script&lang=js"
import style0 from "./AstraTopElementPlannedBonusTableColumn.vue?vue&type=style&index=0&id=2aa12367&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa12367",
  null
  
)

export default component.exports